<div *ngIf="errors">
  <div class="text-warning" *ngFor="let error of errors">{{error}}</div>
</div>
